<template>
  <div class="heroImageCont"
       :class="{home: headerBackground === 'home',
                clients: headerBackground === 'clients',
                cands: headerBackground === 'candidates',
                stories: headerBackground === 'stories',
                about: headerBackground === 'about',
                work: headerBackground === 'work',
                news: headerBackground === 'news',
                research: headerBackground === 'research'}">
    <div class="heroInnerWrapper">
      <div class="heroInner">

        <component
          :is="headerContents"
        />

      </div>
    </div>
  </div>
</template>

<script>
import RareHomeHeaderContents from '../../pages/homeProducts/components/RareHomeHeaderContents';
import RareCandidatesHeaderContents from '../../pages/candidates/components/RareCandidatesHeaderContents';
import RareResearchHeaderContents from '../../pages/research/components/RareResearchHeaderContents';
import RareClientsHeaderContents from './headerContents/RareClientsHeaderContents';
import RareStoriesHeaderContents from '../../pages/stories/components/RareStoriesHeaderContents';
import RareAboutHeaderContents from '../../pages/about/components/RareAboutHeaderContents';
import RareWorkHeaderContents from '../../pages/workForRare/components/RareWorkForRareHeaderContents';
import RareNewsHeaderContents from '../../pages/news/components/RareNewsHeaderContents';
import Rare404HeaderContents from '../../pages/errorNotFound/components/Rare404HeaderContents';
import RareInternalServerHeaderContents from '../../pages/errorInternalServer/components/RareInternalServerHeaderContents';


export default {
  name: 'HeaderHeroImage',
  components: {
    'rare-home-header-contents': RareHomeHeaderContents,
    'rare-clients-header-contents': RareClientsHeaderContents,
    'rare-candidates-header-contents': RareCandidatesHeaderContents,
    'rare-research-header-contents': RareResearchHeaderContents,
    'rare-stories-header-contents': RareStoriesHeaderContents,
    'rare-about-header-contents': RareAboutHeaderContents,
    'rare-work-header-contents': RareWorkHeaderContents,
    'rare-news-header-contents': RareNewsHeaderContents,
    'rare-404-header-contents': Rare404HeaderContents,
    'rare-internal-server-header-contents': RareInternalServerHeaderContents,
  },

  props: {
    headerContents: {
      type: String,
      required: false,
    },
    headerBackground: {
      type: String,
      required: false,
      default: 'home',
    },
  },
};
</script>

<style lang="scss" scoped>

@import "~@/css/global.scss";

.heroImageCont {
  background-size: cover;
  position: relative;
  width: 100%;
}

.heroInnerWrapper {
  position: absolute;
  z-index: 0;
  top:0;
  left:0;
  bottom: 0;
  right: 0;
}

.heroInner {
  height: 100%;
}

@media only screen and (max-width: 640px)  {

  .heroImageCont:before{
    content: "";
    display: block;
    padding-top: 100%;
  }

  .stories {
    background-position: 80% 0% !important;
  }

  .cands {
    background-position: 80% 0% !important;
  }

  .research {
    background-position: 80% 0% !important;
  }

  .work {
    background-position: center top;
    background-image: url("../../assets/img/backgrounds/work-for-us-hero-image-small.jpg") !important;
  }


}

@media only screen and (min-width: 641px)  {

  .heroImageCont:before{
    content: "";
    display: block;
    padding-top: 50%;
  }

}


.home {
  background-position: left top;
  background-image: none;
  background-color: $dark-grey-background;
}

.clients {
  background-position: right top;
  background-image: url("../../assets/img/backgrounds/clients-hero-image.jpg");
}

.cands {
  background-position: right top;
  background-image: url("../../assets/img/backgrounds/candidates-hero-image.jpg");
}

.research {
  background-position: right top;
  background-image: url("../../assets/img/backgrounds/research-hero-image.jpg");
}

.stories {
  background-position: right top;
  background-image: url("../../assets/img/backgrounds/stories-hero.jpg");
}

.about {
  background-position: center top;
  background-image: url("../../assets/img/backgrounds/about-hero-image.jpg");
}

.work {
  background-position: center top;
  background-image: url("../../assets/img/backgrounds/work-for-us-hero-image.jpg");
}

.research {
  background-position: center top;
  background-image: url("../../assets/img/backgrounds/research-hero-image.jpg");
}

</style>



// WEBPACK FOOTER //
// src/components/header/HeaderHeroImage.vue